import { Modal } from 'antd'
import React from 'react'
import ViewingRecord from './Viewing Record'
import CalendarSlotAction from './Calendar Slot Action'

const FullCalendarContentModal = ({
  modalOpen,
  event,
  setModalData,
  refreshFunction,
  selectedProfessional,
  medicalProfessionals
}) => {
  const recordData = event?.extendedProps?.recordData
  const isNew = !recordData
  const selectedMedicalProfessionalRecord = medicalProfessionals.find((medProf) => medProf._id === selectedProfessional)

  // Different widths for different modal types
  const modalWidth = isNew ? 1200 : 850 // 1200px for booking, 850px for viewing

  return (
    <Modal
      width={modalWidth}
      footer={false}
      destroyOnClose
      maskClosable={false}
      closable={false}
      onCancel={() => {}}
      open={modalOpen}
      className='viewing-record-modal'
      styles={{
        body: {
          backgroundColor: '#f0f8ff',
          padding: '20px',
          borderRadius: '8px'
        }
      }}
    >
      {event ? (
        <>
          {isNew ? (
            <CalendarSlotAction
              selectedProfessional={selectedMedicalProfessionalRecord}
              medicalProfessionals={medicalProfessionals}
              event={event}
              setEvent={setModalData}
              refreshFunction={refreshFunction}
            />
          ) : (
            <ViewingRecord
              data={recordData}
              setModalOpen={setModalData}
              setData={setModalData}
              medicalProfessionals={medicalProfessionals}
              refreshFunction={refreshFunction}
            />
          )}
        </>
      ) : undefined}
      {/* {viewingRecord && viewingData ? (
      <>
        {viewingData?.isOpen ? (
          <>
            <CalendarSlotAction
              setEvent={setViewingData}
              event={viewingData}
              refreshFunction={fetchAppointments}
              medicalProfessionals={medicalProfessionals}
              setIsNewAction={setIsNewAction}
              medicalProfessional={medicalProfessionals.find((i) => i._id === viewingData?.resourceId)}
            />
          </>
        ) : (
          <ViewingRecord
            medicalProfessionals={medicalProfessionals}
            setData={setViewingData}
            setIsNewAction={setIsNewAction}
            event={viewingData}
            data={viewingData?.recordData}
            refreshFunction={fetchAppointments}
          />
        )}
      </>
    ) : null}
    {isNewAction ? (
      <>
        <CalendarSlotAction
          setIsNewAction={setIsNewAction}
          refreshFunction={fetchAppointments}
          medicalProfessionals={medicalProfessionals}
        />
      </>
    ) : null} */}
    </Modal>
  )
}

export default FullCalendarContentModal
